//
import axios from "axios";
const { language_switch, page_name, site, is_mobile_device } = window.tg;

let controller;
// Autocomplete component.

/**
 * suggestion:[{
 *      name: "Top Regions",
 *      options: [
 *          { index: 0, name: "Karoo", permalink: "karoo" }
 *      ]
 * }]
 */
export default () => {
    return {
        open: false,
        index: -1,
        highlightedOption: 0,
        suggestions: [],
        history: {},
        ajaxList: [
            'results.favourites.list',
            'results.region',
            'results.map',
        ],
        groupIcons: {
            'Search History': 'fa-clock-rotate-left',
            'Escape from the city': 'fa-car-bus',
            'Stays outside of the city': 'fa-house',
            'Top Regions': 'fa-location-smile',
            'Region': 'fa-location-dot',
            'People': 'fa-user',
            'Places': 'fa-house',
            'Attraction': 'fa-map-pin',
        },
        init() {

            // Enable ajax if on a results page by default.
            this.$store.search.ajax = this.ajaxList.includes(page_name)
            this.index = this.$store.search.ajax && this.$store.search.autocomplete.query.length > 0 ? 0 : -1;

            // Check for exact match on input value when option is not selected.
            this.$watch('open', (newOpen, oldOpen) => {
                // Pick the first option if the input value matches the option name and permalink
                if (newOpen === false && oldOpen) {
                    this.$store.search.activeSection = '';

                    let optionName = this.getOptionByIndex(0)?.name ?? ''
                    let optionPermalink = this.getOptionByIndex(0)?.permalink ?? ''

                    // Pick the first option if the input value matches the option name and permalink
                    if (this.suggestions.length
                        && this.$store.search.autocomplete.query.length
                        && optionName.length
                        && optionName.toLowerCase() == (this.$store.search.autocomplete.query).toLowerCase()
                        && optionPermalink.toLowerCase() == (this.$store.search.autocomplete.permalink).toLowerCase()
                    ) {
                        this.index = 0;
                        this.highlightedOption = 0;
                    } else if (this.index == -1 || this.suggestions.length == 0) {
                        this.$store.search.autocomplete.permalink = ''

                        // Reset the input value to previous value.
                        if (this.history.hasOwnProperty('query') && this.history.query.length > 0) {
                            // reset to previous value
                            this.$store.search.autocomplete.query = this.history.query
                            this.$store.search.autocomplete.permalink = this.history.permalink
                            this.history = {}
                        }
                    }

                    if (this.$store.search.autocomplete.query.length > 0) {
                        this.$store.search.houseKeeping()
                    }

                }

                // scroll to top if homepage on mobile device
                if (newOpen === true && oldOpen === false && is_mobile_device && page_name == 'homepage.index') {
                    setTimeout(() => {
                        document.getElementById('search-form-container').scrollIntoView({block: 'start', inline: 'nearest', behavior: 'smooth'});
                    }, 100);
                }
            })

            this.$watch('index', (newIndex, oldIndex) => {

                if (newIndex > -1 && oldIndex !== newIndex) {
                    let option = this.getOptionByIndex(newIndex)
                    this.$store.search.autocomplete.query = option.name
                    this.$store.search.autocomplete.permalink = option.permalink
                    this.$store.search.ajax = false
                }
            })

            // Changed via search/store to enforce housekeeping
            this.$watch('$store.search.activeSection', (newValue) => {
                if (newValue == 'autocomplete') {
                    this.open = true
                    this.$refs.query.focus() // Triggers dispatch of 'focus' event.
                }
            })

            // Clear autocomplete query when focusing on autocomplete input so that user can just start typing
            this.$refs.query.addEventListener('focus', () => {
                this.$store.search.autocomplete.query = ''
            })
            // Put previous query back if no new query was entered
            this.$refs.query.addEventListener('focusout', () => {
                if (this.$store.search.autocomplete.query == '') {
                    this.$store.search.autocomplete.query = this.$store.search.autocomplete.previousQuery
                }
            })
        },
        async update(query) {
            this.$store.search.autocomplete.query = query;
            this.suggestions = await this.getSuggestions(this.$store.search.autocomplete.query);
            this.highlightedOption = 0
        },
        enter() {
            // Check for exact match on input value when option is not selected.
            let option = this.getOptionByIndex(this.highlightedOption)
            let chosenOption = false
            if (option && option.permalink.includes('social/profile')) {
                chosenOption = option
            }

            this.selectOption(this.highlightedOption, chosenOption)
        },
        selectOption(index, redirectOption=false) {
            if (this.suggestions.length) {
                this.index = index
                this.highlightedOption = 0 // Reset the highlighted option to be the first
            } else {
                // Customer entered a value that does not match any of the options.
                this.$store.search.submit()
            }
            this.open = false;

            if (redirectOption) {
                // Update history
                this.$store.search.autocomplete.query = redirectOption.name
                this.$store.search.autocomplete.permalink = redirectOption.permalink
                this.$store.search.localStorageAutocompleteHistory()

                // Redirect to permalink
                window.location.href = redirectOption.permalink
            }
       },
        previous() {
            const totalOptions = this.suggestions.at(-1)?.options.at(-1)?.index // Get the last option index which indicated total number of options.
            if (totalOptions > 0 && this.highlightedOption > 0) {
                this.highlightedOption--;
            }
        },
        next() {
            const totalOptions = this.suggestions.at(-1)?.options.at(-1)?.index // Get the last option index which indicated total number of options.
            if (totalOptions > 0 && this.highlightedOption < totalOptions) {
                this.highlightedOption++;
            }
        },
        getOptionByIndex(index) {
            if (this.suggestions.length == 0) {
                return ''
            }

            let group = filter(this.suggestions, "index", index)
            // find the option in group with index
            let option = group.options.find(option => option.index === index)

            return option
        },
        getSuggestions(query) {
            if (controller) controller.abort("Operation canceled due to new request.")

            const storeHistory = this.$store.search.history
            controller = new AbortController();
            return axios.get(`/forms/autocomplete/autocomplete.php?site=${site}&lang=${language_switch}&query=${query}`, {
                signal: controller.signal,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            })
                .then(function (response) {
                    let index = 0
                    let data = [];
                    let suggestions = response.data.suggestions ?? []

                    // Filter matching history items.
                    if (storeHistory.length > 0) {
                        for (let history of storeHistory) {
                            if (query == "" || history.query.toLowerCase().includes(query.toLowerCase())) {
                                data.push({
                                    group: _t('kd.global.search_history', "Search History"),
                                    name: history.query,
                                    permalink: history.permalink,
                                    start: history.start,
                                    end: history.end,
                                    allocation_adult: history.adult,
                                    allocation_child: history.child,
                                    count_label: '',
                                    count: 0,
                                })
                            }
                        }
                    }

                    if (suggestions.length === 0 && data.length === 0) {
                        return [];
                    }

                    if (suggestions.length > 0){
                        suggestions.forEach(suggestion => {

                            data.push({
                                group: language_switch == 'en' ? suggestion.data.category_label : suggestion.data.category,
                                name: suggestion.value,
                                permalink: suggestion.data.permalink,
                                count_label: suggestion.data.count_label ?? '',
                                count: suggestion.data.count ?? 0,
                                start: '',
                                end: '',
                                allocation_adult: '',
                                allocation_child: '',
                            })
                        })
                    }

                    const groups = Object.entries(
                        data.reduce((acc, { name, group, permalink, count_label, count, start, end, allocation_adult, allocation_child }) => {
                            // Group initialization
                            if (!acc[group]) {
                                acc[group] = [];
                            }
                            acc[group].push({ name, permalink, index: index++, count_label: count_label, count: count, start: start, end: end, allocation_adult: allocation_adult, allocation_child: allocation_child});

                            return acc;
                        }, {})
                    ).map(([name, options]) => ({ name, options }));

                    return groups
                })
                .catch(function (error) {
                    console.log("🚀 error", error)
                    return [];
                });
        },
        highlight(text) {
            if (this.$store.search.autocomplete.query == undefined || this.$store.search.autocomplete.query.length == 0) return text

            const regex = new RegExp(`(${escapeRegExChars(this.$store.search.autocomplete.query)})`, 'gi');
            return text.replace(regex, `<span class="font-weight-bold">$1</span>`)
        },
        focus(){
            // Store init values for undo if customer only focused and unfocused the input.
            this.history = { ...this.$store.search.autocomplete}
            this.$store.search.autocomplete.query = ''
            this.$store.search.autocomplete.permalink = ''
            if (this.$refs.query == undefined) {
                document.querySelector(".autocomplete input").focus()
            } else {
                this.$refs.query.focus()
            }
        }
    };
};

const escapeRegExChars = (value) => {
    return value.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}

const filter = (object, key, value) => {
    if (Array.isArray(object)) {
        for (const obj of object) {
            const result = filter(obj, key, value);
            if (result) {
                return obj;
            }
        }
    } else {
        if (object.hasOwnProperty(key) && object[key] === value) {
            return object;
        }

        for (const k of Object.keys(object)) {
            if (typeof object[k] === "object") {
                const o = filter(object[k], key, value);
                if (o !== null && typeof o !== 'undefined')
                    return o;
            }
        }

        return null;
    }
}
